import { FC } from 'react';
import {
  Box,
  Center,
  Icon,
  Image,
  Text,
  VStack,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';

import { standardizeUrl } from '@frx/frx-services';

import { StarsFilledLeft, StarsFilledRight } from '../../assets';

import { formatDollarAmount } from '../../utils';

/**
 * @prop memberDisplayName
 * @prop amountRaised
 * @prop photoUrl
 */
export interface TopTeamMemberProps {
  memberDisplayName: string;
  amountRaised: number;
  photoUrl: string;
}

export const TopTeamMember: FC<TopTeamMemberProps> = (props): JSX.Element => {
  const { memberDisplayName, amountRaised, photoUrl } = props;

  const displayAmountRaised = formatDollarAmount(amountRaised);
  const imageUrl = standardizeUrl(photoUrl, true);

  // A display name might be long, so split over two lines where possible
  const [displayNameFirstPart, displayNameLastPart] = (
    memberDisplayName || ''
  ).split(' ');

  return (
    <Box
      bgColor="brand.secondary.swatch9"
      color="white"
      p="0.5rem"
      borderRadius="8px"
    >
      <VStack spacing="2">
        <Center>
          <Text fontSize="lg">Top Team Fundraiser</Text>
        </Center>

        <Center>
          <Icon as={StarsFilledLeft} boxSize="48px" />
          <Image
            mt="0.5rem"
            alt="Top Team Member"
            src={imageUrl}
            w="60px"
            h="60px"
            borderRadius="50%"
          />
          <Icon as={StarsFilledRight} boxSize="48px" />
        </Center>

        <Wrap justify="center">
          <WrapItem>
            <Center>
              <Text fontSize="xl">{displayNameFirstPart}</Text>
            </Center>
          </WrapItem>
          {displayNameLastPart && (
            <WrapItem>
              <Center>
                <Text fontSize="xl">{displayNameLastPart}</Text>
              </Center>
            </WrapItem>
          )}
        </Wrap>
        <Center>{displayAmountRaised}</Center>
      </VStack>
    </Box>
  );
};
